"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewDocument = function NewDocument(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.4996 9.99269C16.4994 9.98082 16.4989 9.96898 16.4978 9.95717C16.4975 9.95286 16.4972 9.94853 16.4967 9.94419C16.4951 9.92997 16.493 9.91583 16.4902 9.90181C16.4893 9.89742 16.4881 9.89317 16.4871 9.8888C16.4849 9.87903 16.4825 9.86936 16.4797 9.85961C16.4779 9.85367 16.4761 9.84783 16.4741 9.842C16.4713 9.83367 16.4682 9.82519 16.4649 9.817C16.4629 9.81175 16.4609 9.80647 16.4587 9.80133C16.4532 9.78886 16.4474 9.77653 16.4409 9.76444C16.4389 9.76058 16.4365 9.75689 16.4344 9.75308C16.4293 9.74411 16.4239 9.73528 16.4183 9.72658C16.4155 9.72228 16.4125 9.71806 16.4096 9.71381C16.4038 9.70558 16.3977 9.6975 16.3914 9.68955C16.3886 9.686 16.3859 9.68236 16.3829 9.67883C16.3737 9.66794 16.3642 9.65728 16.354 9.64708C16.3538 9.64692 16.3537 9.64669 16.3535 9.64655L12.3536 5.64658L12.3532 5.64614C12.3429 5.63594 12.3322 5.62639 12.3213 5.61719C12.3178 5.61428 12.3142 5.61164 12.3107 5.60869C12.3027 5.60238 12.2946 5.59631 12.2863 5.5905C12.2821 5.58756 12.278 5.58464 12.2736 5.58181C12.2649 5.57625 12.256 5.57069 12.247 5.56569C12.2433 5.56353 12.2396 5.56122 12.2358 5.55917C12.2237 5.55269 12.2113 5.54678 12.1988 5.54136C12.1937 5.53914 12.1885 5.53725 12.1833 5.53519C12.1749 5.53189 12.1666 5.52878 12.158 5.52594C12.1522 5.524 12.1464 5.52217 12.1406 5.52039C12.1308 5.51761 12.1209 5.51503 12.1109 5.51278C12.1067 5.51181 12.1026 5.51064 12.0983 5.50978C12.0843 5.507 12.0701 5.50489 12.0558 5.50331C12.0515 5.50283 12.0473 5.50253 12.043 5.50217C12.0311 5.50113 12.0192 5.50053 12.0073 5.50036C12.0048 5.50036 12.0024 5.5 12 5.5H8C7.86739 5.5 7.74021 5.55268 7.64645 5.64645C7.55268 5.74021 7.5 5.86739 7.5 6V18.0001C7.5 18.1327 7.55268 18.2598 7.64645 18.3536C7.74021 18.4474 7.86739 18.5001 8 18.5001H16C16.1326 18.5001 16.2598 18.4474 16.3536 18.3536C16.4473 18.2598 16.5 18.1327 16.5 18.0001V10.0001C16.5 9.99755 16.4997 9.99517 16.4996 9.99269Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.3508 9.6439C16.3471 9.64021 16.3436 9.63618 16.3397 9.6326L12.3536 5.64648C12.4001 5.69286 12.4369 5.74796 12.462 5.80862C12.4872 5.86928 12.5001 5.9343 12.5 5.99996V8.99996C12.5 9.13256 12.5527 9.25974 12.6464 9.35351C12.7402 9.44728 12.8674 9.49996 13 9.49996H16C16.1313 9.49982 16.2574 9.55155 16.3508 9.6439Z",
    fill: props.foregroundColor
  }));
};

NewDocument.defaultProps = {
  altText: "New Document",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
NewDocument.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = NewDocument;
exports.default = _default;